<!--Vista de inicio del dashboard del ORGANIZADOR WECHAMBER
    Se muestran las gráficas circulares, tablas de eventos, afiliaciones, boletos y últimas transacciones de eventos y afiliaciones
-->
<template>
  <v-container fluid>
    <v-row justify="center">
      <v-col cols="12">
        <v-row justify="center" class="mb-3 mb-md-10">
          <v-col cols="12">
            <analytic-list></analytic-list>
          </v-col>
        </v-row>
        <!-- <v-row justify="center">
          <v-col cols="11">
            <line-area-chart></line-area-chart>
          </v-col>
        </v-row>-->
        <v-row justify="space-around" class="mb-10">
          <v-col cols="11" sm="5" class="elevation-2 pa-5">
            <new-event-doughnut-chart></new-event-doughnut-chart>
          </v-col>
          <!--Volver a poner si la gráfica original presenta problemas-->
          <!--<v-col cols="11" sm="5" class="elevation-2 pa-5">
            <event-doughnut-chart></event-doughnut-chart>
          </v-col>-->
          <v-col cols="11" sm="5" class="elevation-2 pa-5">
            <plan-doughnut-chart></plan-doughnut-chart>
          </v-col>
        </v-row>
        <v-row justify="space-around" class="mb-10">
          <!--<v-col cols="11" class="pa-0 mb-10">
            <events-table></events-table>
          </v-col>-->
          <v-col cols="11" class="pa-0 mb-10">
            <new-events-table></new-events-table>
          </v-col>
          <v-col cols="11" class="pa-0">
            <plans-table></plans-table>
          </v-col>
        </v-row>
        <v-row justify="center">
          <v-col cols="11" class="pa-0 mb-10">
            <tickets-table></tickets-table>
          </v-col>
          <v-col cols="11" class="pa-0 mb-10">
            <transactions-table></transactions-table>
          </v-col>
          <v-col cols="11" class="pa-0 mb-10">
            <affiliation-transactions-table></affiliation-transactions-table>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
//import lineAreaChart from "@/components/admin/charts/lineAreaChart/lineAreaChart";
import newEventDoughnutChart from "@/components/admin/charts/eventDoughnutChart/newEventDoughnutChart"
//import eventDoughnutChart from "@/components/admin/charts/eventDoughnutChart/eventDoughnutChart";
import planDoughnutChart from "@/components/admin/charts/planDoughnutChart/planDoughnutChart";
import AnalyticList from "@/components/admin/analytics/analytic-list";
//import EventsTable from "@/components/admin/datatables/eventsTable";
import NewEventsTable from "@/components/admin/datatables/newEventsTable";
import PlansTable from "@/components/admin/datatables/plansTable";
import TicketsTable from "@/components/admin/datatables/ticketsTable";
import TransactionsTable from "@/components/admin/datatables/transactionsTable";
import AffiliationTransactionsTable from "@/components/admin/datatables/affiliationTransactionsTable";
import { mapState, mapActions } from "vuex";
export default {
  components: {
    //lineAreaChart,
    newEventDoughnutChart,
    //eventDoughnutChart,
    planDoughnutChart,
    AnalyticList,
    //EventsTable,
    NewEventsTable,
    PlansTable,
    TicketsTable,
    TransactionsTable,
    AffiliationTransactionsTable
  },
  data() {
    return {
      
    };
  },
  computed: {
    ...mapState('user', ['user']),
  },
};
</script>

